import { createContext, MutableRefObject, useContext } from 'react';

export type ComboboxContextValue = {
  multiple?: boolean;
};

const ComboboxContext = createContext<ComboboxContextValue | undefined>(undefined);

export const ComboboxProvider = ComboboxContext.Provider;

/**
 * Optional version that returns undefined when outside provider.
 * Useful for child components to gracefully fall back to prop-only behavior.
 */
export const useComboboxContextOptional = () => useContext(ComboboxContext);

// ── Anchor context ──────────────────────────────────────────────────
// Provided by Combobox root. ComboboxChips writes its wrapper ref here;
// ComboboxContent reads it as a fallback anchor.

const ComboboxAnchorContext = createContext<MutableRefObject<HTMLDivElement | null> | undefined>(
  undefined,
);

export const ComboboxAnchorProvider = ComboboxAnchorContext.Provider;

export const useComboboxAnchorContext = () => useContext(ComboboxAnchorContext);
